import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKoken = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      d="M28 31H12a4 4 0 0 1-4-4V15h24v12a4 4 0 0 1-4 4M9.95 11.785l20.13-1.56a1.92 1.92 0 0 1 2.062 1.766l.006.08L8.22 13.925l-.006-.08a1.92 1.92 0 0 1 1.736-2.06"
    />
    <path
      fill="#C2DEF6"
      d="M35 33H5a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2"
    />
    <path
      fill="#0061CD"
      d="M16.05 11.31a4.012 4.012 0 1 1 8-.62l-2 .15a2.007 2.007 0 0 0-4 .31z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M6.768 16.232A2.5 2.5 0 0 0 5 15.5v-1A3.5 3.5 0 0 1 8.5 18h-1a2.5 2.5 0 0 0-.732-1.768M35 15.5a2.5 2.5 0 0 0-2.5 2.5h-1a3.5 3.5 0 0 1 3.5-3.5z"
      clipRule="evenodd"
    />
    <path
      fill="#C2DEF6"
      d="M24.5 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M25 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2M26.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M28.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#C2DEF6"
      d="M28 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKoken);

export default ForwardRef;
